import Vue from 'vue'
import { URL_ORGANIZATIONS } from '@/constants/urls'
import { PREPAYMENT_SETTINGS_MANAGEMENT, ERRORS, AXIOS_REQUESTS } from '@/constants/store.js'

const state = {
  [PREPAYMENT_SETTINGS_MANAGEMENT.STATE.PREPAYMENT_SETTINGS]: null,
  [PREPAYMENT_SETTINGS_MANAGEMENT.STATE.CURRENT_PREPAYMENT_SETTINGS]: null
}

const actions = {
  async [PREPAYMENT_SETTINGS_MANAGEMENT.ACTIONS.GET_PREPAYMENT_SETTINGS] ({ dispatch, commit }, params) {
    const model = {
      url: `${Vue.getIdentityHost()}${URL_ORGANIZATIONS}/list/prepaymentSettings?${Vue.helpers.getQueryParamsString(params)}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(PREPAYMENT_SETTINGS_MANAGEMENT.MUTATIONS.GET_PREPAYMENT_SETTINGS, resp.data)
  },
  async [PREPAYMENT_SETTINGS_MANAGEMENT.ACTIONS.EDIT_PREPAYMENT_SETTING] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_ORGANIZATIONS}/${model.organizationId}/prepaymentSettings`,
      model: model.prepayment
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [PREPAYMENT_SETTINGS_MANAGEMENT.ACTIONS.GET_ORGANIZATION_PREPAYMENT_SETTING] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_ORGANIZATIONS}/${model.organizationId}/prepaymentSettings`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(PREPAYMENT_SETTINGS_MANAGEMENT.MUTATIONS.GET_ORGANIZATION_PREPAYMENT_SETTING, resp.data)
  },
  async [PREPAYMENT_SETTINGS_MANAGEMENT.ACTIONS.CLEAR_PREPAYMENT_SETTINGS] ({ commit }) {
    commit(PREPAYMENT_SETTINGS_MANAGEMENT.MUTATIONS.CLEAR_PREPAYMENT_SETTINGS)
  },
  async [PREPAYMENT_SETTINGS_MANAGEMENT.ACTIONS.CLEAR_ORGANIZATION_PREPAYMENT_SETTING] ({ commit }) {
    commit(PREPAYMENT_SETTINGS_MANAGEMENT.MUTATIONS.CLEAR_ORGANIZATION_PREPAYMENT_SETTING)
  }
}

const mutations = {
  [PREPAYMENT_SETTINGS_MANAGEMENT.MUTATIONS.GET_PREPAYMENT_SETTINGS] (state, model) {
    state[PREPAYMENT_SETTINGS_MANAGEMENT.STATE.PREPAYMENT_SETTINGS] = model
  },
  [PREPAYMENT_SETTINGS_MANAGEMENT.MUTATIONS.GET_ORGANIZATION_PREPAYMENT_SETTING] (state, model) {
    state[PREPAYMENT_SETTINGS_MANAGEMENT.STATE.CURRENT_PREPAYMENT_SETTINGS] = model
  },
  [PREPAYMENT_SETTINGS_MANAGEMENT.MUTATIONS.CLEAR_PREPAYMENT_SETTINGS] (state) {
    state[PREPAYMENT_SETTINGS_MANAGEMENT.STATE.PREPAYMENT_SETTINGS] = null
  },
  [PREPAYMENT_SETTINGS_MANAGEMENT.MUTATIONS.CLEAR_ORGANIZATION_PREPAYMENT_SETTING] (state) {
    state[PREPAYMENT_SETTINGS_MANAGEMENT.STATE.CURRENT_PREPAYMENT_SETTINGS] = null
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
